import { render, staticRenderFns } from "./ConsignmentNotesRegistryEdit.vue?vue&type=template&id=6791b174&"
import script from "./ConsignmentNotesRegistryEdit.vue?vue&type=script&lang=js&"
export * from "./ConsignmentNotesRegistryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports